import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Form,
  Button,
  Row,
  Col,
  Container,
  Table,
  Card,
  Spinner,
} from "react-bootstrap";
import axios from "axios";

const pricePerSize = {
  "6": 2.5,
  "7": 3.0,
  "8": 3.5,
};

const UpdateOrder1 = ({ redirectPath = "/customer/ManageOrder" }) => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [note, setNote] = useState("");
  const [items, setItems] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    axios.get(`${API_BASE}/api/orders/${orderId}`, { headers })
      .then((res) => {
        const data = res.data;
        setOrder(data);
        setNote(data.customer_note || "");
        setItems(data.items || []);
      })
      .catch((err) => {
        console.error("Failed to load order", err);
      })
      .finally(() => setLoading(false));
  }, [orderId]);

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...items];
    updatedItems[index][field] = value;

    if (field === "size") {
      updatedItems[index].unit_price = pricePerSize[value] || 0;
    }

    setItems(updatedItems);
  };

  const handleAddItem = () => {
    const newItem = {
      bread_type: "white",
      size: "6",
      quantity: 1,
      unit_price: pricePerSize["6"],
    };
    setItems([...items, newItem]);
  };

  const handleRemoveItem = (index) => {
    const updatedItems = [...items];
    updatedItems.splice(index, 1);
    setItems(updatedItems);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      ...order,
      customer_note: note,
      items,
    };

    try {
      const token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };

      await axios.put(`http://localhost:5000/api/orders/${orderId}`, payload, { headers });

      setSuccessMessage("Order updated successfully!");

      setTimeout(() => {
        navigate(redirectPath);
      }, 1000);
    } catch (err) {
      console.error("Update failed", err);
      alert("Failed to update order");
    }
  };

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" />
        <p>Loading order...</p>
      </Container>
    );
  }

  if (!order) return <p>Order not found.</p>;

  return (
    <Container className="mt-4">
      <h2>Edit Order #{orderId}</h2>

      {successMessage && (
        <Card className="mb-4 border-success" bg="light">
          <Card.Body className="text-success fw-bold d-flex align-items-center">
            <i className="bi bi-check-circle-fill me-2"></i>
            {successMessage}
          </Card.Body>
        </Card>
      )}

      <Form onSubmit={handleSubmit}>
        <Form.Group as={Row} className="mb-3">
          <Form.Label column sm={3}>Customer ID</Form.Label>
          <Col sm={9}>
            <Form.Control
              type="number"
              value={order.customer_id}
              readOnly
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} className="mb-3">
          <Form.Label column sm={3}>Note</Form.Label>
          <Col sm={9}>
            <Form.Control
              as="textarea"
              rows={2}
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </Col>
        </Form.Group>

        <h5>Items</h5>
        <Button variant="success" className="mb-3" onClick={handleAddItem}>
          + Add Item
        </Button>

        <Table bordered>
          <thead>
            <tr>
              <th>#</th>
              <th>Bread</th>
              <th>Size</th>
              <th>Qty</th>
              <th>Unit Price</th>
              <th>Total</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>
                  <Form.Select
                    value={item.bread_type}
                    onChange={(e) => handleItemChange(index, "bread_type", e.target.value)}
                  >
                    <option value="white">White</option>
                    <option value="whole wheat">Whole Wheat</option>
                  </Form.Select>
                </td>
                <td>
                  <Form.Select
                    value={item.size}
                    onChange={(e) => handleItemChange(index, "size", e.target.value)}
                  >
                            <option value="7">7"</option>
                            <option value="8">8"</option>
                            <option value="9">9"</option>
                            <option value="10">10"</option>
                            <option value="11">11"</option>
                            <option value="12">12"</option>
                  </Form.Select>
                </td>
                <td>
                  <Form.Control
                    type="number"
                    min="1"
                    value={item.quantity}
                    onChange={(e) => handleItemChange(index, "quantity", e.target.value)}
                  />
                </td>
                <td>${Number(item.unit_price).toFixed(2)}</td>
                <td>${(item.unit_price * item.quantity).toFixed(2)}</td>
                <td>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => handleRemoveItem(index)}
                  >
                    Remove
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        <Button type="submit" variant="primary" disabled={items.length === 0}>
          Update Order
        </Button>
      </Form>
    </Container>
  );
};

export default UpdateOrder1;
